/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_QuestionInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use both tools instead of choosing only one?`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能否同时使用两款工具？`)
};

/**
* | output |
* | --- |
* | "Can I use both tools instead of choosing only one?" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_3_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_question(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_question(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_3_question as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.3.question" }